<div style="margin-top:250px; margin-bottom:250px;">
    <center>
        <div class="spinner-border text-danger" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        Caricamento in corso...
    </center>
</div>
